//
// scroll vers le formulaire
//
let form = document.getElementById('form');

if (form) {
    let href = form.getAttribute('data-href');
    let targetE = href && document.getElementById(href);

    if (targetE) {
        window.scroll({
            behavior: 'smooth',
            top: targetE.offsetTop,
        });
    }
}

//
// validation puis envoi des formulaires ayant la classe "ani-form"
//
let formSubmits = document.querySelectorAll('form.ani-form button[type=submit]');

formSubmits.forEach(formSubmit => {
    formSubmit.addEventListener('click', function (event) {
        let form = formSubmit.closest('form');

        if (!form.classList.contains('validated')) {
            event.preventDefault();

            if (form.checkValidity()) {
                if (document.querySelector('body').classList.contains('local') || !form.classList.contains('form-recaptcha')) {
                    form.classList.add('validated');
                    formSubmit.click();
                } else {
                    if (form.querySelector('.response')) {
                        grecaptcha.enterprise.ready(() => {
                            grecaptcha.enterprise.execute(global.form_recaptcha_key, {
                                action: 'submit',
                            }).then(token => {
                                document.querySelector('.response').value = token;
                                form.submit();
                            });
                        });
                    } else {
                        form.classList.add('validated');
                        formSubmit.click();
                    }
                }
            } else {
                form.classList.add('was-validated');
            }
        }
    });
});